import styled from 'styled-components';
export const Wrapper = styled.div`
  padding: 0 20px;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
`;
export const Container = styled.div`
  padding: 0 20px;
  width: 100%;
  @media (max-width: 768px) {
    width: auto;
    padding: 0 1rem;
  }
`;
export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  max-width: 800px;
  margin: 0 auto;
`;
export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
`;
export const SectionContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.backgroundHover};
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
`;
export const DashboardContainer = styled.div`
  width: 100%;
  @media (max-width: 768px) {
    width: auto;
    padding: 0 1rem;
  }
`;
export const SectionTitle = styled.h3`
  margin-top: 0;
  margin-bottom: 15px;
  color: ${({ theme }) => theme.colors.text.primary};
  font-size: 18px;
`;
export const FieldRow = styled.div`
  display: flex;
  gap: 20px;
  margin-bottom: 15px;
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 10px;
  }
`;
export const FieldColumn = styled.div`
  flex: 1;
`;
